import { create } from 'zustand'

import { BusinessUnit } from '@shared/constants/brands'
import EditionState from '@modules/Edition/Presentation/store/EditionState'
import editionRepository from '@modules/Edition/Infrastructure/Repository/EditionRepository'

export const useEditionStore = create<EditionState>((set, get) => {
  return {
    editions: [],
    getEditions: async (businessUnit: string) => {
      const editions = await editionRepository.getEditions(businessUnit)

      set((state) => {
        if (businessUnit === BusinessUnit.AS) {
          return { editions }
        }

        const uniqueEditions = editions.filter(
          (newEdition) => !state.editions.some((existing) => existing.id === newEdition.id)
        )

        return {
          editions: [...state.editions, ...uniqueEditions]
        }
      })
    },
    resetEditions: () => {
      set({ editions: [] })
    }
  }
})